"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ExpandableFlexTableRow = exports.FlexTableRow = void 0;

var _react = _interopRequireDefault(require("react"));

var _flow = _interopRequireDefault(require("lodash/flow"));

var _propTypes = require("prop-types");

var Table = _interopRequireWildcard(require("reactabular-table"));

var _styles = require("@material-ui/core/styles");

var _Table = _interopRequireDefault(require("@material-ui/core/Table"));

var _TableRow = _interopRequireDefault(require("@material-ui/core/TableRow"));

var _TableBody = _interopRequireDefault(require("@material-ui/core/TableBody"));

var _TableHead = _interopRequireDefault(require("@material-ui/core/TableHead"));

var _Divider = _interopRequireDefault(require("@material-ui/core/Divider"));

var _Collapse = _interopRequireDefault(require("@material-ui/core/Collapse"));

var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _withOpenability = _interopRequireDefault(require("../hoc/with-openability"));

var _customTable = require("./custom-table");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var flexColumnStyles = {
  root: {
    display: 'flex',
    flexDirection: 'column'
  }
}; // eslint-disable-next-line prefer-arrow-callback

var UnwrappedFlexTableContainer = _react.default.forwardRef(function FlexTableContainer(props, ref) {
  return _react.default.createElement(_Table.default, _extends({
    component: "div",
    role: "table",
    ref: ref
  }, props));
});

var FlexTableContainer = (0, _styles.withStyles)(flexColumnStyles, {
  name: 'FlexTableContainer'
})(UnwrappedFlexTableContainer); // eslint-disable-next-line prefer-arrow-callback

var UnwrappedFlexTableBody = _react.default.forwardRef(function FlexTableBody(props, ref) {
  return _react.default.createElement(_TableBody.default, _extends({
    component: "div",
    role: "rowgroup",
    ref: ref
  }, props));
}); // eslint-disable-next-line prefer-arrow-callback


var FlexTableBody = (0, _styles.withStyles)(flexColumnStyles, {
  name: 'FlexTableBody'
})(UnwrappedFlexTableBody);

var flexTableHeadStyles = function flexTableHeadStyles(_ref) {
  var palette = _ref.palette;
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      borderBottom: "1px solid ".concat(palette.grey[300])
    }
  };
}; // eslint-disable-next-line prefer-arrow-callback


var UnwrappedFlexTableHead = _react.default.forwardRef(function FlexTableHead(props, ref) {
  return _react.default.createElement(_TableHead.default, _extends({
    component: "div",
    role: "rowgroup",
    ref: ref
  }, props));
}); // eslint-disable-next-line prefer-arrow-callback


var FlexTableHead = (0, _styles.withStyles)(flexTableHeadStyles, {
  name: 'FlexTableHead'
})(UnwrappedFlexTableHead);

var flexRowStyles = function flexRowStyles(_ref2) {
  var spacing = _ref2.spacing;
  return {
    root: {
      display: 'flex',
      minHeight: spacing(6)
    }
  };
}; // eslint-disable-next-line prefer-arrow-callback


var UnwrappedFlexTableRow = _react.default.forwardRef(function FlexTableRow(props, ref) {
  return _react.default.createElement(_TableRow.default, _extends({
    component: "div",
    role: "row",
    ref: ref
  }, props));
}); // eslint-disable-next-line prefer-arrow-callback


var FlexTableRow = (0, _styles.withStyles)(flexRowStyles, {
  name: 'FlexTableRow'
})(UnwrappedFlexTableRow);
exports.FlexTableRow = FlexTableRow;

var expandableFlexRowStyles = function expandableFlexRowStyles(theme) {
  return {
    root: _objectSpread({}, flexRowStyles(theme).root, {
      cursor: 'pointer'
    }),
    collapsedIcon: {
      transition: "transform ".concat(theme.transitions.duration.shortest, "ms"),
      transform: 'rotate(0deg)'
    },
    expandedContainer: {
      background: theme.palette.grey[50]
    },
    expandedIcon: {
      transition: "transform ".concat(theme.transitions.duration.shortest, "ms"),
      transform: 'rotate(180deg)'
    },
    iconButton: {
      padding: 0
    },
    expandIconCell: {
      paddingTop: '12px',
      paddingBottom: '12px'
    }
  };
}; // eslint-disable-next-line prefer-arrow-callback


var UnwrappedExpandableFlexTableRow = _react.default.forwardRef(function FlexTableCell(props, ref) {
  var classes = props.classes,
      openable = props.openable,
      RenderExpandable = props.expandableRowContentComponent,
      rowData = props.rowData,
      children = props.children,
      rest = _objectWithoutProperties(props, ["classes", "openable", "expandableRowContentComponent", "rowData", "children"]);

  var cellCount = _react.default.Children.count(children);

  var cells = _react.default.Children.map(children, function (child, index) {
    if (index !== cellCount - 1) {
      return child;
    }

    var expandIconClass = openable.open ? classes.expandedIcon : classes.collapsedIcon;
    return _react.default.cloneElement(child, {
      classes: {
        root: classes.expandIconCell
      },
      children: _react.default.createElement(_IconButton.default, {
        size: "small",
        classes: {
          root: classes.iconButton
        }
      }, _react.default.createElement(_ExpandMore.default, {
        classes: {
          root: expandIconClass
        }
      }))
    });
  });

  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_TableRow.default, _extends({
    component: "div",
    role: "row",
    classes: {
      root: classes.root
    },
    ref: ref
  }, rest, {
    onClick: openable.handleToggle
  }), cells), _react.default.createElement(_Collapse.default, {
    classes: {
      container: classes.expandedContainer
    },
    timeout: "auto",
    in: openable.open,
    mountOnEnter: true,
    unmountOnExit: true
  }, _react.default.createElement(RenderExpandable, rowData), _react.default.createElement(_Divider.default, null)));
});

process.env.NODE_ENV !== "production" ? UnwrappedExpandableFlexTableRow.propTypes = {
  children: (0, _propTypes.arrayOf)(_propTypes.object).isRequired,
  classes: _propTypes.object.isRequired,
  expandableRowContentComponent: _propTypes.func.isRequired,
  openable: _propTypes.object.isRequired,
  rowData: _propTypes.object.isRequired
} : void 0;
var ExpandableFlexTableRow = (0, _flow.default)((0, _withOpenability.default)(), (0, _styles.withStyles)(expandableFlexRowStyles, {
  name: 'ExpandableFlexTableRow'
}))(UnwrappedExpandableFlexTableRow);
exports.ExpandableFlexTableRow = ExpandableFlexTableRow;
var flexCellStyles = {
  root: {
    display: 'inline-flex',
    alignItems: 'center'
  }
}; // eslint-disable-next-line prefer-arrow-callback

var UnwrappedFlexTableCell = _react.default.forwardRef(function FlexTableCell(props, ref) {
  return _react.default.createElement(_customTable.CustomTableCell, _extends({
    component: "div",
    role: "cell",
    ref: ref
  }, props));
});

var FlexTableCell = (0, _styles.withStyles)(flexCellStyles, {
  name: 'FlexTableCell'
})(UnwrappedFlexTableCell);
var flexColumnHeaderStyles = {
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    borderBottom: 'none'
  }
}; // eslint-disable-next-line prefer-arrow-callback

var UnwrappedFlexColumnHeader = _react.default.forwardRef(function FlexColumnHeader(props, ref) {
  return _react.default.createElement(_customTable.CustomTableCell, _extends({
    component: "div",
    role: "columnheader",
    ref: ref
  }, props));
});

var FlexColumnHeader = (0, _styles.withStyles)(flexColumnHeaderStyles, {
  name: 'FlexColumnHeader'
})(UnwrappedFlexColumnHeader);

var FlexTable = function FlexTable(_ref3) {
  var expandableRows = _ref3.expandableRows,
      props = _objectWithoutProperties(_ref3, ["expandableRows"]);

  return _react.default.createElement(Table.Provider, _extends({}, props, {
    renderers: {
      table: FlexTableContainer,
      header: {
        wrapper: FlexTableHead,
        row: FlexTableRow,
        cell: FlexColumnHeader
      },
      body: {
        wrapper: FlexTableBody,
        row: expandableRows ? ExpandableFlexTableRow : FlexTableRow,
        cell: FlexTableCell
      }
    }
  }));
};

process.env.NODE_ENV !== "production" ? FlexTable.propTypes = {
  children: _propTypes.node.isRequired,
  columns: (0, _propTypes.arrayOf)(_propTypes.object).isRequired,
  expandableRows: _propTypes.bool
} : void 0;
FlexTable.defaultProps = {
  expandableRows: false
};
var _default = FlexTable;
exports.default = _default;